// --------------------- Import Global ---------------------
import axios from "axios";
import Globais, { validateToken } from "../components/Globais";

export const buscarUsuarioProprietarioByCel = async (celular: string) => {
  const URL = `${Globais.DOMINIOBACK}/usuario/celular/${celular}`;

  try {
    const response = await axios.get(URL);

    if (response && response.data) {
      return response.data;

      // Retorna true se tudo correr bem e o array não estiver vazio
    } else {
      return false;
    }
  } catch (error) {
    console.error(error);
  }
};
